import application_settings from '../applicationSettings';
import Event from './Event';

class GetProduct extends Event {
    eventName = 'oms_getProduct';

    constructor() {
        super();
        this.add();
    }

    /**
     * @override
     * 
     * Event Function for Get settings
     * 
     * @param {string} data.product_id -  product id given for product
     * @param {string} data.super_attributes -  super attributes given for product
     * @return void
     *  
     */
    eventFunction(data) {
        let clientId = data.client_id;
        let thisObj = this;
        let requestId = (data.request_id) ? data.request_id : '';
        let action = (data.action) ? data.action : '';

        // request data
        data.endPoint = application_settings.endPoints.getProduct;
        data.data = {
            client_id: clientId,
            product_id: data.product_id,
            order_currency:data.order_currency,
            super_attributes: (data.super_attributes) ? data.super_attributes : null
        };
    
        this.sendRequest(data, function (response) {
            if (response) {
                //format response data
                let data = thisObj.formatResponseData(response);

                //fire success event
                thisObj.onSuccessEvent(data, {'action' : action, 'request_id' : requestId });
            }
        });
        
    }
}

export default GetProduct;